enum LocalStorageKey{  
    Auth='Auth',
    Notes='Notes',
    Comments='Comments'
}

export default LocalStorageKey